import React, { Fragment } from 'react';
import SearchBar from './SearchBar';
import SearchOption from './SearchOption';


function Header ({
  isSearched, searchQuery, updateSearchQuery, searchVideos,
  sortOption, isSortLayerOpen, openSortLayer, closeSortLayer, updateSortOption,
}) {
  return (
    <div className="head_layer">
      <strong className="tit_head">Youtube 동영상 첨부</strong>
      {isSearched &&
        <Fragment>
          <SearchBar
            searchQuery={searchQuery}
            updateSearchQuery={updateSearchQuery}
            searchVideos={searchVideos}
          />
          <SearchOption
            sortOption={sortOption}
            isSortLayerOpen={isSortLayerOpen}
            openSortLayer={openSortLayer}
            closeSortLayer={closeSortLayer}
            updateSortOption={updateSortOption}
            searchVideos={searchVideos}
          />
        </Fragment>
      }
    </div>
  );
}

export default Header;
